import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { Apollo } from 'apollo-angular';
import {
	GET_UNIVERSITY_RATING_STATS,
	GET_UNIVERSITY_REVIEW,
	GET_UNIVERSITY_REVIEWS,
} from '../queries.graphql';
import {
	QueryParamsState,
	Reaction,
	ReactionType,
} from '../../models/university-reviews.models';
import {
	UniversityRatingStatsResponse,
	UniversityReviewsResponse,
	UniversityReviewResponse,
} from '@uc/web/shared/data-models';
import { EnvironmentApiService } from '@uc/web/config';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class UniversityReviewsApiService {
	constructor(
		private _apollo: Apollo,
		private _http: HttpClient,
		private _apiSrv: EnvironmentApiService,
	) {}

	getUniversityRatingStats(args: { universityUrl: string }) {
		return this._apollo
			.query<UniversityRatingStatsResponse>({
				query: GET_UNIVERSITY_RATING_STATS,
				variables: {
					university: args.universityUrl,
				},
			})
			.pipe(map(({ data }) => data.universityRatings));
	}

	getUniversityReviews(
		args: Partial<QueryParamsState> & Pick<QueryParamsState, 'university'>,
	) {
		return this._apollo
			.query<UniversityReviewsResponse>({
				query: GET_UNIVERSITY_REVIEWS,
				variables: {
					university: args.university,
					page: args.page,
					limit: args.limit,
					contains: args.contains,
					sortBy: args.sortBy,
					offset: args.offset,
				},
			})
			.pipe(
				map(({ data }) => {
					return data.universityReviews;
				}),
			);
	}

	getUniversityReview(reviewId: number) {
		return this._apollo
			.query<UniversityReviewResponse>({
				query: GET_UNIVERSITY_REVIEW,
				variables: {
					reviewId,
				},
			})
			.pipe(map(({ data }) => data));
	}

	voteOnReview(reviewId: number, reaction: ReactionType) {
		return reaction === Reaction.LIKE
			? this._upvoteReview(reviewId)
			: this._downvoteReview(reviewId);
	}

	private _upvoteReview(reviewId: number) {
		return this._http.post(`${this._apiSrv.API_URL}reviews/${reviewId}/like`, {
			transferCache: false,
		});
	}

	private _downvoteReview(reviewId: number) {
		return this._http.post(`${this._apiSrv.API_URL}reviews/${reviewId}/dislike`, {
			transferCache: false,
		});
	}
}
